export const reactSelectClassNames = (errors = null, fieldName = null) => {
  overwriteStyles();
  const borderClass = (errors && fieldName && errors[fieldName]) ? "lox-react-select-error " : "lox-react-select-default"
  return {
    control: () => `lox-react-select-container lox-react-select-container__height ${borderClass}`,
    valueContainer: () => "lox-react-select-value-container",
    input: () => "lox-react-select-input",
    indicatorsContainer: () => "lox-react-select-indicators-container"
  }
};

export const reactMultiSelectClassNames = (errors = null, fieldName = null) => {
  overwriteStyles();
  const borderClass = (errors && fieldName && errors[fieldName]) ? "lox-react-select-error " : "lox-react-select-default"
  return {
    control: () => `lox-react-select-container ${borderClass}`,
    input: () => "lox-react-select-input",
    indicatorsContainer: () => "lox-react-select-indicators-container"
  }
};

const overwriteStyles = () => import('../assets/scss/lox-react-select-style.scss');
// according to react-select docs
// You must ensure that your provided styles are declared later than the styles from React Select
// @ref: https://react-select.com/styles#the-classnames-prop  "Note on CSS specificity"
